// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internals-filter-card {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 14px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-sm);
  padding: 16px;
  margin: 0 0 16px;
}

.internals-filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px 16px;
}

.internals-filter-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.internals-filter-field label {
  font-size: 13px;
  font-weight: 600;
  color: var(--texto-destaque);
  margin: 0;
}

.internals-filter-field input,
.internals-filter-field select {
  margin: 0;
}

.internals-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid var(--ui-border);
  padding-top: 12px;
}

.internals-filter-actions .btn-edit,
.internals-filter-actions .save-btn {
  min-width: 140px;
  padding: 10px 16px;
}

@media (max-width: 600px) {
  .internals-filter-actions {
    flex-direction: column-reverse;
  }

  .internals-filter-actions .btn-edit,
  .internals-filter-actions .save-btn {
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InternalsFilterPanel/internalsFilterPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;EACT,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".internals-filter-card {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  gap: 14px;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-sm);\n  padding: 16px;\n  margin: 0 0 16px;\n}\n\n.internals-filter-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px 16px;\n}\n\n.internals-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.internals-filter-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--texto-destaque);\n  margin: 0;\n}\n\n.internals-filter-field input,\n.internals-filter-field select {\n  margin: 0;\n}\n\n.internals-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  border-top: 1px solid var(--ui-border);\n  padding-top: 12px;\n}\n\n.internals-filter-actions .btn-edit,\n.internals-filter-actions .save-btn {\n  min-width: 140px;\n  padding: 10px 16px;\n}\n\n@media (max-width: 600px) {\n  .internals-filter-actions {\n    flex-direction: column-reverse;\n  }\n\n  .internals-filter-actions .btn-edit,\n  .internals-filter-actions .save-btn {\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
